import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./exam.css";
import "./uploadResultFile.css";

const GRADE_COLORS = {
  "A+": { bg: "#d1fae5", color: "#065f46" },
  "A":  { bg: "#dcfce7", color: "#166534" },
  "B+": { bg: "#dbeafe", color: "#1e40af" },
  "B":  { bg: "#e0f2fe", color: "#075985" },
  "C":  { bg: "#fef3c7", color: "#92400e" },
  "D":  { bg: "#ffedd5", color: "#9a3412" },
  "F":  { bg: "#fee2e2", color: "#991b1b" },
};

export default function ResultList() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState("");

  const loadResults = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/results/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setResults(res.data.results || []);
    } catch {
      console.error("Failed to load results");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadResults(); }, []);

  const filtered = results.filter(r =>
    !search ||
    r.student_name?.toLowerCase().includes(search.toLowerCase()) ||
    r.exam_name?.toLowerCase().includes(search.toLowerCase()) ||
    r.subject?.toLowerCase().includes(search.toLowerCase())
  );

  const gradeStyle = (grade = "") => {
    const key = grade.trim().toUpperCase();
    return GRADE_COLORS[key] || { bg: "#f1f5f9", color: "#64748b" };
  };

  return (
    <div className="urf-page">

      {/* ══ HERO ══ */}
      <div className="urf-hero">
        <div className="urf-hero-left">
          <div className="urf-hero-icon">🏆</div>
          <div>
            <h2 className="urf-hero-title">Student Results</h2>
            <p className="urf-hero-sub">
              {loading ? "Loading…" : `${results.length} result record${results.length !== 1 ? "s" : ""}`}
            </p>
          </div>
        </div>
      </div>

      {/* ══ SEARCH ══ */}
      <div style={{
        background: "#fff",
        border: "1.5px solid #e2e8f0",
        borderRadius: "14px",
        padding: "14px 18px",
        marginBottom: "20px",
        boxShadow: "0 2px 12px rgba(0,0,0,.05)",
      }}>
        <input
          type="text"
          placeholder="🔍  Search by student, exam, or subject…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{
            width: "100%", border: "none", outline: "none",
            fontSize: "14px", color: "#334155", background: "transparent",
          }}
        />
      </div>

      {/* ══ TABLE ══ */}
      <div style={{
        background: "#fff",
        border: "1.5px solid #e2e8f0",
        borderRadius: "16px",
        overflow: "hidden",
        boxShadow: "0 4px 24px rgba(0,0,0,.07)",
      }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          <thead>
            <tr style={{ background:"linear-gradient(135deg,#2e1065,#4c1d95,#7c3aed)" }}>
              {["Exam","Student","Subject","Marks","Grade"].map(h => (
                <th key={h} style={{
                  padding:"14px 16px", textAlign:"left",
                  fontSize:"11px", fontWeight:800,
                  textTransform:"uppercase", letterSpacing:".06em",
                  color:"#fff",
                }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" style={{ textAlign:"center", padding:"52px 24px", color:"#94a3b8" }}>
                  <div style={{ fontSize:40, marginBottom:10 }}>⏳</div>
                  <div style={{ fontWeight:700 }}>Loading results…</div>
                </td>
              </tr>
            ) : filtered.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign:"center", padding:"52px 24px", color:"#94a3b8" }}>
                  <div style={{ fontSize:44, marginBottom:10 }}>🏆</div>
                  <div style={{ fontWeight:700, color:"#1e293b", marginBottom:4 }}>No Results Found</div>
                  <div style={{ fontSize:13 }}>
                    {search ? "Try a different search term" : "No result records yet"}
                  </div>
                </td>
              </tr>
            ) : (
              filtered.map((r, i) => (
                <tr
                  key={r.id || i}
                  style={{
                    borderBottom:"1px solid #f1f5f9",
                    transition:".15s",
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = "#f5f3ff"}
                  onMouseLeave={e => e.currentTarget.style.background = ""}
                >
                  <td style={{ padding:"14px 16px", fontSize:"13px", color:"#64748b" }}>
                    <span style={{
                      background:"#ede9fe", color:"#5b21b6",
                      padding:"3px 10px", borderRadius:"6px",
                      fontSize:"12px", fontWeight:700,
                    }}>
                      {r.exam_name}
                    </span>
                  </td>
                  <td style={{ padding:"14px 16px", fontWeight:700, color:"#1e293b", fontSize:"14px" }}>
                    {r.student_name}
                  </td>
                  <td style={{ padding:"14px 16px", fontSize:"13px", color:"#334155" }}>
                    {r.subject}
                  </td>
                  <td style={{ padding:"14px 16px", fontWeight:800, color:"#4c1d95", fontSize:"15px" }}>
                    {r.marks}
                  </td>
                  <td style={{ padding:"14px 16px" }}>
                    {r.grade ? (
                      <span style={{
                        ...gradeStyle(r.grade),
                        padding:"4px 12px", borderRadius:"20px",
                        fontSize:"12px", fontWeight:800,
                        textTransform:"uppercase",
                      }}>
                        {r.grade}
                      </span>
                    ) : "—"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

    </div>
  );
}
